import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

import * as exeljs from 'exceljs/dist/exceljs.min.js';
import * as xlsx from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExportExcelService {

  fileName =  'GTT_EXPORT_';

  currentCompany: any;

  constructor() {
    this.currentCompany = JSON.parse(localStorage.getItem('company'));
  }

  export(table?: any[], filename = null, opts = {}): boolean {

      if (table) {

        const ws = xlsx.utils.json_to_sheet(table, opts);

        /* generate workbook and add the worksheet */
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, 'data');

        /* save to file */
        let fileName = filename ? filename : this.fileName;
        xlsx.writeFile(wb, fileName + '_' +new Date().getTime() + '.xlsx');
        return true;

      } else {
        return false;
      }
  }

  exportExcelWithExcelJs(excelData) {

    //Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers;
    const data = excelData.data;

    //Create a workbook with a worksheet

    let workbook = new exeljs.Workbook();
    let worksheet = workbook.addWorksheet('Fiche suiveuse');


    //Add Row and formatting
    worksheet.mergeCells('D1', 'G4');
    let titleRow = worksheet.getCell('D1');
    titleRow.value = title
    titleRow.font = {
      name: 'Calibri',
      size: 18,
      underline: 'single',
      bold: true,
      color: { argb: '0085A3' }
    }
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' }

    // Date
    worksheet.mergeCells('G1:H4');
    let d = new Date();
    let date = d.getDate() + '-' + d.getMonth() + '-' + d.getFullYear();
    let dateCell = worksheet.getCell('G1');
    dateCell.value = date;
    dateCell.font = {
      name: 'Calibri',
      size: 12,
      bold: true
    }
    dateCell.alignment = { vertical: 'middle', horizontal: 'center' }

    //Add Image
    let myLogoImage = workbook.addImage({
      base64: this.currentCompany.logo,
      extension: 'png',
    });
    worksheet.mergeCells('A1:B4');
    worksheet.addImage(myLogoImage, 'A1:B4');

    //Blank Row
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '4167B8' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
    })

    // Adding Data with Conditional Formatting
    data.forEach(d => {
        let row = worksheet.addRow(d);

        let sales = row.getCell(6);
        let color = 'FF99FF99';
        if (+sales.value < 200000) {
          color = 'FF9999'
        }

        sales.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color }
        }
      }
    );

    worksheet.getColumn(3).width = 20;
    worksheet.addRow([]);

    //Footer Row
    let footerRow = worksheet.addRow(['Employee Sales Report Generated from example.com at ' + date]);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFB050' }
    };

    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, title + '.xlsx');
    });


  }

}
